import {isFiltered} from "../miscellaneous/functions"
import {bestBoundWithTimeLimit} from "../miscellaneous/functionsCOP"
import {types} from "../miscellaneous/constants"


function createCactusData(selectedSolvers, data, benchmarks, filters) {
    let tmp = [];
    let data2 = [];
    for (let i = 0; i < selectedSolvers.length; i++)
        if (data[selectedSolvers[i].id] === undefined)
            return []
    let max = -1
    for (let j = 0; j < selectedSolvers.length; j++) {
        let s = selectedSolvers[j];
        let t = data[s.id].filter(e => isFiltered(filters, e) && e.time < filters.timeLimit && e.bug === 0).map(e => e.time)
        if(max < t.length)
            max = t.length
        t.sort((time1, time2) => time1 - time2);
        data2[s.id] = t;
    }

    for(let i = 0; i < max; i++) {
        let current = {"nb": i + 1};
        for (let j = 0; j < selectedSolvers.length; j++) {
            let s = selectedSolvers[j];
            if (data2[s.id][i] !== undefined)
                current[s.name + " " + s.version] = parseInt(data2[s.id][i]);
        }
        tmp.push(current);
    }
    return tmp;

}



function createScatterData(data, benchmarks, filters, solvers) {
    if (solvers == null)
        return null
    const s1 = solvers.solver1.id;
    const s2 = solvers.solver2.id;
    let tmp = []
    for (let b of benchmarks)
        tmp[b.id] = {...b}

    for(let d of data[s1])
        tmp[d.benchmark_id].t1 = d.time < filters.timeLimit && d.bug === 0? (d.time === 0 ? 1 : d.time) :filters.timeLimit

    for(let d of data[s2])
        tmp[d.benchmark_id].t2 = d.time < filters.timeLimit && d.bug === 0 ? (d.time === 0 ? 1 : d.time) :filters.timeLimit


    let scatters= {'SAT' : [], 'UNSAT' : []}
    for(let b of benchmarks) {
        if(!isFiltered(filters, b))
            continue
        if(b.status == "SAT")
            scatters['SAT'].push(tmp[b.id])
        if(b.status == "UNSAT")
            scatters['UNSAT'].push(tmp[b.id])
    }

    return scatters
}


function createConstraintsData(data, benchmarks, filters, solvers) {
    let tmp = []
    let constraints = []
    const SAT_solver1= solvers.solver1.name + " " + solvers.solver1.version + " #SAT"
    const SAT_solver2= solvers.solver2.name + " " + solvers.solver2.version + " #SAT"
    const UNSAT_solver1= solvers.solver1.name + " " + solvers.solver1.version + " #UNSAT"
    const UNSAT_solver2= solvers.solver2.name + " " + solvers.solver2.version  + " #UNSAT"

    const s1 = solvers.solver1.id;
    const s2 = solvers.solver2.id;


    for (let b of benchmarks) {
        if (!isFiltered(filters, b))
            continue
        let tmp2 = b.info_constraints.split("#").map(e => e.split(":")[0])
        for (let i = 1; i < tmp2.length; i++)
            if (!constraints.includes(tmp2[i]))
                constraints.push(tmp2[i])

    }
    constraints.sort()
    for (let f of constraints)
        tmp.push({name: f, [SAT_solver1]: 0, [SAT_solver2]: 0, [UNSAT_solver1]: 0, [UNSAT_solver2]: 0})


    for (let b of benchmarks) {
        if (!isFiltered(filters, b))
            continue
        let tmp2 = b.info_constraints.split("#").map(e => e.split(":")[0])
        let pos = []
        for (let i = 1; i < tmp2.length; i++)
            pos.push(constraints.indexOf(tmp2[i]))

        let d1 = null
        let d2 = null
        for (let d of data[s1])
            if (d.benchmark_id == b.id) {
                d1 = d
                break
            }
        for (let d of data[s2])
            if (d.benchmark_id == b.id) {
                d2 = d
                break
            }

        if(d1.time < filters.timeLimit && d1.bug === 0)
            if(d1.status == "SAT")
                for(let p of pos)
                    tmp[p][SAT_solver1]++
            else
                for(let p of pos)
                    tmp[p][UNSAT_solver1]++

        if(d2.time < filters.timeLimit && d2.bug === 0)
            if(d2.status == "SAT")
                for(let p of pos)
                    tmp[p][SAT_solver2]++
            else
                for(let p of pos)
                    tmp[p][UNSAT_solver2]++
    }

    return tmp
}

function createFamiliesData(data, benchmarks, filters, solvers) {


    let tmp = []
    let families = []

    const SAT_solver1= solvers.solver1.name + " " + solvers.solver1.version + " #SAT"
    const SAT_solver2= solvers.solver2.name + " " + solvers.solver2.version + " #SAT"
    const UNSAT_solver1= solvers.solver1.name + " " + solvers.solver1.version + " #UNSAT"
    const UNSAT_solver2= solvers.solver2.name + " " + solvers.solver2.version  + " #UNSAT"

    const s1 = solvers.solver1.id;
    const s2 = solvers.solver2.id;


    for (let b of benchmarks) {
        if (!isFiltered(filters, b) || families.includes(b.family))
            continue
        families.push(b.family)
    }
    families.sort()
    for (let f of families)
        tmp.push({name: f, [SAT_solver1]: 0, [SAT_solver2]: 0, [UNSAT_solver1]: 0, [UNSAT_solver2]: 0})

    for (let b of benchmarks) {
        if (!isFiltered(filters, b))
            continue
        const pos = families.indexOf(b.family)
        let d1 = null
        let d2 = null
        for (let d of data[s1])
            if (d.benchmark_id == b.id) {
                d1 = d
                break
            }
        for (let d of data[s2])
            if (d.benchmark_id == b.id) {
                d2 = d
                break
            }

        if(d1.time < filters.timeLimit && d1.bug === 0)
            if(d1.status == "SAT")
                tmp[pos][SAT_solver1]++
            else
                tmp[pos][UNSAT_solver1]++

        if(d2.time < filters.timeLimit && d2.bug === 0)
            if(d2.status == "SAT")
                tmp[pos][SAT_solver2]++
            else
                tmp[pos][UNSAT_solver2]++
    }
    return tmp
}




function createGraphsData(data, benchmarks, filters, solvers, type) {
    switch (type) {
        case types.scatter:
            return createScatterData(data, benchmarks, filters, solvers)

        case types.families:
            return createFamiliesData(data, benchmarks, filters, solvers)

        case types.constraints:
            return createConstraintsData(data, benchmarks, filters, solvers)

    }
}


export {createCactusData, createGraphsData}